import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-208a059f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "MiROS | SignIn", -1))
const _hoisted_2 = {
  key: 0,
  class: "error-box center"
}
const _hoisted_3 = { class: "center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "body-text" }, "Email:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "body-text" }, "Password:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))
const _hoisted_7 = { class: "sub-div" }
const _hoisted_8 = { class: "sign-in-btn-div" }
const _hoisted_9 = { class: "body-text subtitle" }
const _hoisted_10 = { class: "sub-div" }
const _hoisted_11 = { class: "body-text subtitle" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "New to MiROS? Click here to become a member: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("html", null, [
    _hoisted_1,
    _createElementVNode("body", null, [
      (_ctx.errMsg != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.errMsg), 1))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_5,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(" If you are a member of RoboCloud, you can sign in using your RoboCloud user ID and password. "),
          _createElementVNode("button", {
            class: "rectangle-button float-right",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args)))
          }, " Sign in ")
        ]),
        _createElementVNode("span", _hoisted_9, [
          _createTextVNode(" Forgot your password? No worries. Click here: "),
          _createVNode(_component_router_link, {
            to: "/login/resetPassword",
            class: "subtitle"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Reset Password")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_router_link, {
            to: "/login/signUp",
            class: "subtitle"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Sign Up")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}